export default "__VITE_ASSET__F4Rb_zEF__"